export const PROCESS_CHARGES_GRID_OPTIONS_DEFAULT = {
    suppressRowClickSelection: true,
    enableCellTextSelection: true,
    ensureDomOrder: true,
    cacheBlockSize: 50,
    maxBlocksInCache: 5,
    rowModelType: 'serverSide',
    pagination: true,
    paginationPageSize: 50,
    paginationPageSizeSelector: [50, 100, 200, 500], // Page size options
    // eslint-disable-next-line consistent-return
    getRowStyle: (params) => {
        if (params.node.level !== 0) {
            return { 'font-weight': 600 };
        }
    }
};

export const PROCESS_CHARGES_GRID_SIDE_BAR_DEFAULT = {
    toolPanels: [
        {
            id: 'columns',
            labelDefault: 'Columns',
            iconKey: 'columns',
            toolPanel: 'agColumnsToolPanel',
            toolPanelParams: {
                suppressRowGroups: true,
                suppressValues: true,
                suppressPivots: true,
                suppressPivotMode: true
            }
        }
    ],
    defaultToolPanel: 'columns'
};

export const PROCESS_CHARGES_DATA_DEFAULT = {
    gridApi: null,
    columnApi: null,
    gridThemeClass: 'ag-theme-quartz',
    rowSelection: 'multiple',
    gridOptions: PROCESS_CHARGES_GRID_OPTIONS_DEFAULT,
    gridSideBar: PROCESS_CHARGES_GRID_SIDE_BAR_DEFAULT,
    defaultColDef: {
        resizable: true,
        sortable: true,
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        filterParams: { maxNumConditions: 1, debounceMs: 1000 }
    },
    columnDefs: []
};
